// Pure assembly of the Profile screen's version/diagnostics panel. Kept free
// of expo-constants / expo-updates so it unit-tests without native modules; the
// screen passes the live values in. Lets testers confirm which app + OTA bundle
// they are running (#104/#133 diagnostics).

export interface VersionInfoInput {
  appVersion?: string | null; // Constants.expoConfig?.version
  runtimeVersion?: string | null; // Updates.runtimeVersion
  channel?: string | null; // Updates.channel
  updateId?: string | null; // Updates.updateId
  createdAt?: Date | null; // Updates.createdAt (OTA publish time)
  isEmbeddedLaunch?: boolean; // Updates.isEmbeddedLaunch
  platform: string; // Platform.OS
}

export interface VersionInfoRow {
  label: string;
  value: string;
}

const DASH = "—";

/** Format an OTA publish date as "YYYY-MM-DD HH:MM UTC", or a dash for null. */
export function formatOtaDate(date: Date | null | undefined): string {
  if (!date) return DASH;
  const iso = date.toISOString(); // 2026-10-09T14:30:00.000Z
  return `${iso.slice(0, 10)} ${iso.slice(11, 16)} UTC`;
}

/**
 * Build the labelled rows for the version-info panel. Pure.
 */
export function buildVersionInfo(input: VersionInfoInput): VersionInfoRow[] {
  const embedded = input.isEmbeddedLaunch === true;
  return [
    { label: "App version", value: input.appVersion || "unknown" },
    { label: "Platform", value: input.platform },
    { label: "Runtime version", value: input.runtimeVersion || DASH },
    { label: "Channel", value: input.channel || DASH },
    {
      label: "Update",
      value: embedded ? "Embedded (store build)" : "OTA update",
    },
    {
      label: "OTA update ID",
      value: embedded || !input.updateId ? DASH : input.updateId.slice(0, 8),
    },
    {
      label: "OTA published",
      value: embedded ? DASH : formatOtaDate(input.createdAt),
    },
  ];
}
